<template>
    <div
        v-loading="loading" style="width:100%; height: calc(100vh);"
        element-loading-text="请稍后，正在登录...">

    </div>
</template>

<script>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessageBox } from 'element-plus'

import userService from '../../services/user.service'

// 用于微信登录时的等待界面（因为不管是微信扫码登录还是微信浏览器自动登录，都需要一个回调页面接收code）
// 用于切换账套，传具体账套的 token 直接登录（也可以应用于第三方登录，如官网已经登录，进入到系统时使用）
export default {
    name: 'tw-login-passport',
    setup() {
        const route = useRoute()
        const router = useRouter()
        const loading = ref(false)

        let loginPromise
        // 如果url中存在 code 时，认为是微信扫码登录或微信浏览器打开自动登录，这两种方式都是传 code
        if (route.query.code) {
            loginPromise = userService.loginForCode(route.query.code, route.query.sob_no)
        }

        if (route.query.token) {
            loginPromise = userService.loginForToken(route.query.token, route.query.sob_no)
        }

        if (loginPromise) {
            loading.value = true
            loginPromise.then(() => {
                // router.push({ name: 'main' })
                // 不使用 router 跳转是为了能让页面刷新，因为需要 router/index.js 单元加载动态路由
                window.location.href = `${process.env.BASE_URL}main`
            }).catch(err => {
                loading.value = false
                ElMessageBox.alert(`登录失败，详情：${err.message}`, '提示信息', {
                    confirmButtonText: '确定',
                    callback: () => {
                        router.push({ name: 'login' })
                    }
                })
            })
        } else {
            // 未提供任何凭证时可能是人为通过url进入，所以跳回到普通登录页面
            router.push({ name: 'login' })
        }

        return {
            loading
        }
    }
}
</script>

<style>

</style>